import type { VideoCall } from '@/types'
import { reportAnchorActivity } from './anchorActivityLogger'

export function reportAnchorHangup(call: VideoCall, result: 'success' | 'failed', error?: unknown) {
  reportAnchorActivity({
    event_type: result === 'success' ? 'call_ended_anchor_hangup' : 'call_ended_anchor_hangup_failed',
    event_source: 'anchor_h5_ui',
    order_id: call.order_id || call.call_id,
    call_direction: call.direction === 'user_to_anchor' ? 'user_to_anchor' : 'anchor_to_user',
    counterparty_user_id: call.user_id || call.from_user_id,
    reason_code: 'anchor_hangup',
    result,
    from_call_phase: 'busy',
    to_call_phase: result === 'success' ? 'ended' : undefined,
    rtc_channel: call.channel_name,
    rtc_uid: call.uid,
    error_message: error instanceof Error ? error.message : undefined,
    metadata: {
      release_target: call.order_id ? 'order' : 'call',
      local_status: call.status,
      order_status: call.order_status,
    },
  })
}
